import React, {memo} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {GifModel} from '../../../../models/api/gifModel';
import {gifsPerRow, gridSpacing} from './gifDropdownCommons';
import {GifDropdownListItem} from './gifDropdownListItem';

/*
 * Props.
 */

interface GifDropdownListRowProps {
  gifs: Array<GifModel>;
  onGifSelect: HandlerOf<GifModel>;
  shouldFillRow?: boolean;
}

/*
 * Style.
 */

const StyledRowDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(${gifsPerRow}, 1fr);
  align-items: start;

  /*
    This side padding and grid-column-cap make up all vertical grid outlines.
    This top padding is the horizontal grid lines.
  */
  padding: ${gridSpacing}px ${gridSpacing}px 0;
  grid-column-gap: ${gridSpacing}px;
`;

/*
 * Component.
 */

export const GifDropdownListRow = memo<GifDropdownListRowProps>(({gifs, onGifSelect, shouldFillRow}) => (
  <StyledRowDiv>
    {gifs.map((gif) => (
      <GifDropdownListItem key={gif.id} gif={gif} onSelect={() => onGifSelect(gif)} />
    ))}
    {shouldFillRow && maybeRenderPlaceholders(gifsPerRow - gifs.length)}
  </StyledRowDiv>
));

/*
 * Helpers.
 */

const maybeRenderPlaceholders = (missingItemsInRow: number) =>
  missingItemsInRow > 0 &&
  // eslint-disable-next-line react/no-array-index-key
  Array.from(Array(missingItemsInRow)).map((_, index) => <GifDropdownListItem key={index} />);
